'use strict'

import {
	ADD_PICKUP_OPERATION,
	ADD_PIEZOMETER_KEY_FIGURE,
	ADD_PIEZOMETER_MEASURE,
	ADD_QUALITOMETER_ANALYSIS,
	ADD_QUALITOMETER_KEY_FIGURE,
	RECEIVE_INDUSTRIAL_SITE,
	RECEIVE_PIEZOMETER,
	RECEIVE_POLLUTED_SOIL,
	RECEIVE_QUALITOMETER,
	RECEIVE_SURFACE_QUALITOMETER,
	RESET_USER_STATION
} from '../constants/DashboardConstants'
import { TOASTR_ERROR } from '../../home/constants/HomeConstants'
import fetch from 'isomorphic-fetch'
import { checkStatus } from '../../utils/ActionUtils'
import download from 'downloadjs'
import { flatten } from 'lodash'
import { WaitAction } from 'react-aquasys'
import { PATH_HOME } from '../../home/constants/HomeConstants'
import { push } from 'react-router-redux'
import SitesType from '../../utils/mapUtils/SiteTypes'
import { getBody } from '../../utils/ActionUtils'
import ApplicationConf from '../../conf/ApplicationConf'
import i18n from 'simple-react-i18n'
import ToastrAction from '../../home/actions/ToastrAction'

const DashboardAction = {

	errorOnFetch: function (content) {
		return {
			type: TOASTR_ERROR,
			message: content
		}
	},

	receivePiezometer: function (piezometers) {
		return {
			type: RECEIVE_PIEZOMETER,
			piezometers: piezometers
		}
	},
	fetchPiezometer: function (login) {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.site.getSiteOfType(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: getBody(login, SitesType.PIEZOMETER.type)
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => [])
				}, response))
				.then((json = []) => {
					dispatch(DashboardAction.receivePiezometer(json))
					return json
				}).then(jsonResult => {
					const allPiezometer = jsonResult.map((result) => {
						return DashboardAction.fetchPiezoKeyFigure(result.idstation)
					})
					Promise.all(allPiezometer).then((values) => {
						const piezometerMeasure = flatten(values)
						dispatch(DashboardAction.receivePiezometerKeyFigure(piezometerMeasure))
					})
					return jsonResult
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
		}
	},
	receiveQualitometer: function (qualitometers) {
		return {
			type: RECEIVE_QUALITOMETER,
			qualitometers: qualitometers
		}
	},
	fetchQualitometer: function (login) {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.site.getSiteOfType(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: getBody(login, SitesType.QUALITOMETER.type)
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => [])
				}, response))
				.then((json = []) => {
					dispatch(DashboardAction.receiveQualitometer(json))
					return json
				}).then(jsonResult => {
					const result = jsonResult.map((o) => {
						return DashboardAction.fetchQualitometerKeyFigure(o.idstation)
					})
					Promise.all(result).then((values) => {
						const pickupOperations = flatten(values)
						dispatch(DashboardAction.receiveQualitometerKeyFigure(pickupOperations))
					})
					const allPiezometer = jsonResult.map((x) => {
						return DashboardAction.fetchPiezoKeyFigure(x.idstation)
					})
					Promise.all(allPiezometer).then((values) => {
						const piezometerMeasure = flatten(values)
						dispatch(DashboardAction.receivePiezometerKeyFigure(piezometerMeasure))
					})
					return jsonResult
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
		}
	},
	receiveSurfaceQualitometer: function (qualitometers) {
		return {
			type: RECEIVE_SURFACE_QUALITOMETER,
			qualitometersSurface: qualitometers
		}
	},
	fetchSurfaceQualitometer: function (login) {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.site.getSiteOfType(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: getBody(login, SitesType.QUALITOMETER_SURFACE.type)
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => [])
				}, response))
				.then((json = []) => {
					dispatch(DashboardAction.receiveSurfaceQualitometer(json))
					return json
				}).then(jsonResult => {
					const result = jsonResult.map((o) => {
						return DashboardAction.fetchQualitometerKeyFigure(o.idstation)
					})
					Promise.all(result).then((values) => {
						const pickupOperations = flatten(values)
						dispatch(DashboardAction.receiveQualitometerKeyFigure(pickupOperations))
					})
					return jsonResult
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
		}
	},
	receivePiezometerMeasure: function (measures) {
		return {
			type: ADD_PIEZOMETER_MEASURE,
			piezometerMeasures: measures
		}
	},
	fetchPiezoMeasures: function (piezometerId) {
		return fetch(ApplicationConf.piezo.getPiezometerMeasure(), {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(
				{
					piezometerid: piezometerId
				})
		})
			.then(response => checkStatus({
				200: ((rep) => rep.json()),
				204: (() => [])
			}, response))
			.then((json = []) => {
				if (!json.error) {
					return json
				}
				return []
			})
	},

	receiveQualitometerKeyFigure: function (keyfigures) {
		return {
			type: ADD_QUALITOMETER_KEY_FIGURE,
			qualitometerKeyFigures: keyfigures
		}
	},
	fetchQualitometerKeyFigure: function (qualitometerId) {
		return fetch(ApplicationConf.qualito.getQualitometerKeyFigure(), {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(
				{
					idstation: qualitometerId
				})
		})
			.then(response => checkStatus({
				200: ((rep) => rep.json()),
				204: (() => [])
			}, response))
			.then((json = []) => {
				if (!json.error) {
					return json
				}
				return []
			})
	},
	receivePiezometerKeyFigure: function (keyfigures) {
		return {
			type: ADD_PIEZOMETER_KEY_FIGURE,
			piezometerKeyFigures: keyfigures
		}
	},
	fetchPiezoKeyFigure: function (piezometerId) {
		return fetch(ApplicationConf.piezo.getPiezometerKeyFigure(), {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(
				{
					idstation: piezometerId
				})
		})
			.then(response => checkStatus({
				200: ((rep) => rep.json()),
				204: (() => [])
			}, response))
			.then((json = []) => {
				if (!json.error) {
					return json
				}
				return []
			})
	},

	receivePickupOperations: function (operations) {
		return {
			type: ADD_PICKUP_OPERATION,
			pickupoperations: operations
		}
	},
	fetchPickupOperation: function (qualitometerId) {
		return fetch(ApplicationConf.qualito.getPickupOperation(), {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(
				{
					idstation: qualitometerId
				})
		})
			.then(response => checkStatus({
				200: ((rep) => rep.json()),
				204: (() => [])
			}, response))
			.then((json = []) => {
				if (!json.error) {
					return json
				}
				return []
			})
	},
	receiveAnalysis: function (analysis) {
		return {
			type: ADD_QUALITOMETER_ANALYSIS,
			analysis: analysis
		}
	},
	fetchAnalysis: function (operationId) {
		return fetch(ApplicationConf.qualito.getAnalysis(), {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(
				{
					idoperation: operationId
				})
		})
			.then(response => checkStatus({
				200: ((rep) => rep.json()),
				204: (() => [])
			}, response))
			.then((json = []) => {
				if (!json.error) {
					return json
				}
				return []
			})
	},

	receivePollutedSoil: function (pollutedSoil) {
		return {
			type: RECEIVE_POLLUTED_SOIL,
			pollutedSoil: pollutedSoil
		}
	},

	fetchPollutedSoil: function (login) {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.site.getSiteOfType(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: getBody(login, SitesType.POLLUTED_SOIL.type)
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => [])
				}, response))
				.then((json = []) => {
					dispatch(DashboardAction.receivePollutedSoil(json))
					return json
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
		}
	},
	receiveIndustrialSites: function (industrialSites) {
		return {
			type: RECEIVE_INDUSTRIAL_SITE,
			industrialSites: industrialSites
		}
	},

	fetchIndustrialSites: function (login) {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.site.getSiteOfType(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: getBody(login, SitesType.INDUSTRIAL_SITE.type)
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => [])
				}, response))
				.then((json = []) => {
					dispatch(DashboardAction.receiveIndustrialSites(json))
					return json
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
		}
	},

	deleteSites: function (ids) {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.sites.addOrRemoveSites(), {
				method: 'DELETE',
				headers: { authorization: btoa('Basic ' + atob(sessionStorage.getItem('TOKEN'))) },
				body: JSON.stringify({ sites: ids })
			})
				.then(() => {
					dispatch(DashboardAction.resetStation())
				}).then(() => {
					dispatch(DashboardAction.fetchUserStation())
				}).then(() => {
					dispatch(WaitAction.waitStop())
				}).then(() => {
					dispatch(ToastrAction.success(i18n.multi.your + ' ' + ids.length + ' ' + i18n.deletedSites))
				}).then(() => {
					dispatch(push(PATH_HOME))
				}).catch((err) => {
					dispatch(ToastrAction.error(i18n.cannotDeleteSite + err))
				})
		}
	},

	resetStation: function () {
		return {
			type: RESET_USER_STATION
		}
	},

	fetchUserStation: function () {
		const login = atob(sessionStorage.getItem('TOKEN'))
		return function (dispatch) {
			dispatch(DashboardAction.fetchPiezometer(login))
			dispatch(DashboardAction.fetchQualitometer(login))
			dispatch(DashboardAction.fetchSurfaceQualitometer(login))
			dispatch(DashboardAction.fetchPollutedSoil(login))
			dispatch(DashboardAction.fetchIndustrialSites(login))
		}
	},

	exportStations() {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.station.export(), {
				method: 'GET',
				headers: { authorization: btoa('Basic ' + atob(sessionStorage.getItem('TOKEN'))) }
			})
				.then(response => checkStatus({
					200: ((rep) => rep.blob())
				}, response))
				.then((blob) => {
					download(blob, 'stations.zip', blob.type)
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
				.catch(err => {
					dispatch(DashboardAction.errorOnFetch(err))
				})
		}
	}
}

export default DashboardAction



// WEBPACK FOOTER //
// ./src/dashboard/actions/DashboardAction.js